import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NzDropdownMenuComponent } from "ng-zorro-antd/dropdown";

@Component({
  selector: "v4-custom-select",
  templateUrl: "./custom-select.component.html",
  styleUrls: ["./custom-select.component.scss"],
})
export class V4CustomSelectComponent implements OnInit {
  // @Input() menu: NzDropdownMenuComponent;
  @Input() showTextItem = false;
  @Input() textItem;
  @Input() placeholder;
  @Input() visible;
  @Input() size: "default" | "large" | "small" = "default";
  @Output() visibleChange = new EventEmitter();

  constructor() {}

  ngOnInit() {}
}
